import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a8fd4c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "pageNation" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hidden" }, "페이지네이션", -1))
const _hoisted_3 = { class: "page-numbers" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "wrap-btn-next" }
const _hoisted_6 = { class: "wrap-btn-prev" }

import { ref, onMounted, watch, reactive } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PageNation',
  props: {
  propsPageNumber: {
    type: Number,
    required: true,
  },
  lastPageNumber: {
    type: Number,
    required: true,
  },
},
  emits: ['onClick_pageNumber'],
  setup(__props, { emit }) {

const props = __props;



var pageNumber = ref(1);
var pageNumbers = reactive([]);
const divNum = 5;
var portion = ref(1);
var remainder = ref(0);
var portionIdx = ref(0);
/**** methods ----------------- */
const setPageDivision = async () => {
  pageNumber.value = 1;
  let firstNum = 1;
  if (props.lastPageNumber < divNum + 1) {
    for (let i = 0; i < props.lastPageNumber; i++) {
      pageNumbers.push(firstNum + i);
    }
  } else {
    portion.value = props.lastPageNumber / divNum;
    remainder.value = props.lastPageNumber % divNum;
    if (remainder.value !== 0) {
      if (pageNumber.value !== props.lastPageNumber) {
        for (let i = 0; i < divNum; i++) {
          pageNumbers.push(firstNum + i);
        }
      } else {
        for (let i = 0; i < remainder.value; i++) {
          pageNumbers.push(firstNum + i);
        }
      }
    } else {
      for (let i = 0; i < divNum; i++) {
        pageNumbers.push(firstNum + i);
      }
    }
  }
};
const onClick_number = (item: number) => {
  pageNumber.value = item;
};
const onClick_next = () => {
  if (pageNumber.value + 1 < props.lastPageNumber) {
    pageNumber.value = pageNumber.value + 1;
  } else {
    pageNumber.value = props.lastPageNumber;
  }
};
const onClick_next_div = () => {
  if (pageNumber.value + 5 < props.lastPageNumber) {
    pageNumber.value = pageNumber.value + 5;
  } else {
    pageNumber.value = props.lastPageNumber;
  }
};
const onClick_next_last = () => {
  pageNumber.value = props.lastPageNumber;
};
const onClick_prev = () => {
  if (pageNumber.value - 1 > 0) {
    pageNumber.value = pageNumber.value - 1;
  } else {
    pageNumber.value = 1;
  }
};
const onClick_prev_div = () => {
  if (pageNumber.value - 5 > 0) {
    pageNumber.value = pageNumber.value - 5;
  } else {
    pageNumber.value = 1;
  }
};
const onClick_prev_last = () => {
  pageNumber.value = 1;
};
/**** content -----------------
 * 페이지네이션
 * /
 * /
/**** hook -------------------- */
onMounted(() => {
  setPageDivision();
});
watch(
  () => props.propsPageNumber,
  async (newValue, oldValue) => {
    pageNumber.value = newValue;
  },
  { deep: true }
);
watch(
  () => props.lastPageNumber,
  async (newValue, oldValue) => {
    pageNumbers = [];
    await setPageDivision();
  },
  { deep: true }
);
watch(
  () => pageNumber.value,
  async (newValue, oldValue) => {
    emit('onClick_pageNumber', newValue);
    if (newValue > pageNumbers[pageNumbers.length - 1]) {
      pageNumbers = [];
      if (newValue % divNum === 0) {
        portionIdx.value = newValue / divNum - 1;
      } else {
        portionIdx.value = Math.floor(newValue / divNum);
      }
      if (pageNumber.value !== props.lastPageNumber) {
        for (let i = 0; i < divNum; i++) {
          pageNumbers[i] = 1 + i + divNum * portionIdx.value;
        }
      } else {
        for (let i = 0; i < props.lastPageNumber % divNum; i++) {
          pageNumbers[i] = 1 + i + divNum * portionIdx.value;
        }
      }
    } else if (newValue < pageNumbers[0]) {
      pageNumbers = [];
      if (newValue <= divNum) {
        portionIdx.value = 0;
        for (let i = 0; i < divNum; i++) {
          pageNumbers[i] = 1 + i;
        }
      } else {
        if (newValue % divNum === 0) {
          portionIdx.value = newValue / divNum - 1;
        } else {
          portionIdx.value = Math.floor(newValue / divNum);
        }
        for (let i = 0; i < divNum; i++) {
          pageNumbers[i] = 1 + i + divNum * portionIdx.value;
        }
      }
    }
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageNumbers), (item) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass([{ on: item === _unref(pageNumber) }]),
          key: item,
          onClick: ($event: any) => (onClick_number(item))
        }, _toDisplayString(item), 11, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "btn-next hidden-font",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick_next()))
      }, "이전"),
      _createElementVNode("button", {
        class: "btn-next-div hidden-font",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onClick_next_div()))
      }, "5페이지 이전"),
      _createElementVNode("button", {
        class: "btn-next-last hidden-font",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (onClick_next_last()))
      }, "처음")
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "btn-prev-last hidden-font",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (onClick_prev_last()))
      }, "마지막"),
      _createElementVNode("button", {
        class: "btn-prev-div hidden-font",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (onClick_prev_div()))
      }, "5페이지 다음"),
      _createElementVNode("button", {
        class: "btn-prev hidden-font",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (onClick_prev()))
      }, "다음")
    ])
  ]))
}
}

})